import {v4 as uuidv4} from 'uuid';

/**
 * Generate a UUID
 * @returns {string} UUID
 */
export default function generateUuid() {
    return uuidv4();
}
